export const getIntialValues = (data = {}) => ({
  meta_seo: {
    meta_title: data?.meta_seo?.meta_title || "",
    meta_keyword: data?.meta_seo?.meta_keyword || "",
    meta_desc: data?.meta_seo?.meta_desc || "",
    meta_slug_url: data?.meta_seo?.meta_slug_url || "",
  },
  banner: {
    image: data?.banner?.image || "",
    heading: {
      white: data?.banner?.heading?.white || "",
      orange: data?.banner?.heading?.orange || "",
    },
    subHeading: data?.banner?.subHeading || "",
    paragraphs: data?.banner?.paragraphs || [""],
    cta_title: data?.banner?.cta_title || "",
    cta_download: data?.banner?.cta_download || "",
  },
  detail: {
    heading: {
      black: data?.detail?.heading?.black || "",
      orange: data?.detail?.heading?.orange || "",
    },
    title: data?.detail?.title || "",
    desc: data?.detail?.desc || "",
    sub_heading: data?.detail?.sub_heading || "",
    paragraphs: data?.detail?.paragraphs || [""],
    sections: data?.detail?.sections || [{ title: "", points: [{ text: "", logo_img: "" }] }],
    image: {
      url: data?.detail?.image?.url || "",
      alt: data?.detail?.image?.alt || "",
    },
  },
  distance: {
    title: data?.distance?.title || "",
    cards: data?.distance?.cards || [{ city: "", distance: "" }],
    bottom_para: data?.distance?.bottom_para || "",
  },
  locationSlider: {
    heading: {
      black: data?.locationSlider?.heading?.black || "",
      orange: data?.locationSlider?.heading?.orange || "",
    },
    sub_heading: data?.locationSlider?.sub_heading || "",
    slides: data?.locationSlider?.slides || [{ image: "", title: "", description: "" }],
  },
  sliderSection: {
    heading: {
      white: data?.sliderSection?.heading?.white || "",
      orange: data?.sliderSection?.heading?.orange || "",
    },
    subHeading: data?.sliderSection?.subHeading || "",
    description: data?.sliderSection?.description || "",
    cards: data?.sliderSection?.cards || [{ title: "", desc: "", img: "" }],
  },
  useCases: {
    heading: {
      title: data?.useCases?.heading?.title || "",
      highlight: data?.useCases?.heading?.highlight || "",
      subtitle: data?.useCases?.heading?.subtitle || "",
    },
    items: data?.useCases?.items || [{ title: "", desc: "", icon_img: "" }],
  },
  offering: {
    title: data?.offering?.title || "",
    highlight: data?.offering?.highlight || "",
    subtitle: data?.offering?.subtitle || "",
    desc: data?.offering?.desc || "",
    image: data?.offering?.image || "",
  },
  infrastructure: {
    infrastructure: {
      title: data?.infrastructure?.infrastructure?.title || "",
      highlight: data?.infrastructure?.infrastructure?.highlight || "",
      subtitle: data?.infrastructure?.infrastructure?.subtitle || "",
      image: data?.infrastructure?.infrastructure?.image || "",
      points: data?.infrastructure?.infrastructure?.points || [{ text: "", icon_img: "" }],
      note: data?.infrastructure?.infrastructure?.note || "",
    },
    safety: {
      title: data?.infrastructure?.safety?.title || "",
      highlight: data?.infrastructure?.safety?.highlight || "",
      subtitle: data?.infrastructure?.safety?.subtitle || "",
      image: data?.infrastructure?.safety?.image || "",
      points: data?.infrastructure?.safety?.points || [{ text: "", icon_img: "" }],
    },
  },
  footer_bgimg: data?.footer_bgimg || "",
});

export const generatePayload = (values) => {
  const { _id, createdAt, updatedAt, __v, ...payload } = values;
  return payload;
};
